__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "stc-factoring-reconciliation-web";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@auth0/auth0-react", "2.3.0", () => (() => (__webpack_require__(8100))), 1);
			register("@pdftron/webviewer", "10.3.0", () => (__webpack_require__.e(421).then(() => (() => (__webpack_require__(421))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(3935))), 1);
			register("react-redux", "8.0.5", () => (Promise.all([__webpack_require__.e(706), __webpack_require__.e(170), __webpack_require__.e(161)]).then(() => (() => (__webpack_require__(6706))))));
			register("react-router-dom", "6.24.1", () => (Promise.all([__webpack_require__.e(818), __webpack_require__.e(170)]).then(() => (() => (__webpack_require__(9818))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(7294))), 1);
			initExternal(1560);
			initExternal(2597);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};